import React, { useEffect, useRef, useState, useCallback } from 'react';

function AutoLogoutWrapper({ children }) {
  const timer = useRef(null);
  const warningTimer = useRef(null);
  const [showWarning, setShowWarning] = useState(false);

  const logout = () => {
    localStorage.clear();
    window.location.href = '/';
  };

  const startTimers = useCallback(() => {
    clearTimeout(timer.current);
    clearTimeout(warningTimer.current);
    setShowWarning(false);

    // Mostrar advertencia 30 segundos antes de cerrar sesión (ej: 4.5 min si total es 5 min)
    warningTimer.current = setTimeout(() => {
      setShowWarning(true);
    }, 25.5 * 60 * 1000);

    // Cerrar sesión a los 5 minutos
    timer.current = setTimeout(logout, 30 * 60 * 1000);
  }, []);

  const handleVisibilityChange = useCallback(() => {
    if (document.hidden) {
      timer.current = setTimeout(logout, 30 * 60 * 1000); // 30 min si se oculta
    } else {
      startTimers();
    }
  }, [startTimers]);

  useEffect(() => {
    const events = ['mousemove', 'keydown', 'click', 'scroll'];
    events.forEach(event => window.addEventListener(event, startTimers));
    document.addEventListener('visibilitychange', handleVisibilityChange);

    startTimers();

    return () => {
      events.forEach(event => window.removeEventListener(event, startTimers));
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      clearTimeout(timer.current);
      clearTimeout(warningTimer.current);
    };
  }, [startTimers, handleVisibilityChange]);

  return (
    <>
      {showWarning && (
        <div style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          backgroundColor: '#ffcc00',
          padding: '16px',
          borderRadius: '8px',
          boxShadow: '0px 2px 10px rgba(0,0,0,0.2)',
          zIndex: 9999
        }}>
          ⚠️ Tu sesión se cerrará en 30 segundos por inactividad
        </div>
      )}
      {children}
    </>
  );
}

export default AutoLogoutWrapper;
